import { Collection, getFirebase } from 'firestorter';
import BaseDocument from '../../Model/BaseDocument';
import Collections from '../../utils/collections';
import { ContactProvider } from './Lead';

const IG_MSG_STATUS = {
  QUEUED: 'queued',
  SENT: 'sent',
  ERROR: 'error',
  PROCESSING: 'processing',
  // Abandoned before sending by the Automated Text Setter — the lead replied, or the automation was
  // turned off while it sat queued. Never sent, so it must not read as sent.
  CANCELLED: 'cancelled',
};

class LeadMsg extends BaseDocument {
  get body() {
    if (this.data.body) {
      return this.data.body;
    }
    return '';
  }

  get attachment() {
    return this.data.attachment || '';
  }

  get contactNo() {
    return this.data.contactNo;
  }

  get from() {
    return this.data.from;
  }

  get to() {
    return this.data.to;
  }

  get hasMedia() {
    return this.data.hasMedia;
  }

  get isFromMe() {
    return this.data.isFromMe;
  }

  get provider() {
    return this.data.provider;
  }

  get subject() {
    return this.data.subject || '';
  }

  get sentAs() {
    return this.data.sentAs;
  }

  get sentAsUsername() {
    return this.data.sentAsUsername;
  }

  get sentAt() {
    return this.data.sentAt.toDate();
  }

  get igMsgStatus() {
    return this.data.igMsgStatus || '';
  }

  get errorMessage() {
    return this.data.errorMessage || '';
  }

  get automatedMsgCancellationReason() {
    return this.data.automatedMsgCancellationReason || '';
  }

  static async getLeadMsgs(contactNo, sendBlueNumber) {
    const leadMsgsCollection = new Collection(Collections.LEAD_MSGS, {
      createDocument: (src, opts) => new LeadMsg(src, opts),
      query: (ref) => ref
        .where('contactNo', '==', contactNo)
        .where('sendblue_number', '==', sendBlueNumber),
    });
    await leadMsgsCollection.fetch();
    return leadMsgsCollection;
  }

  static async getLeadEmails(email) {
    const leadMsgsCollection = new Collection(Collections.LEAD_MSGS, {
      createDocument: (src, opts) => new LeadMsg(src, opts),
      query: (ref) => ref
        .where('contactEmail', '==', email),
    });
    await leadMsgsCollection.fetch();
    return leadMsgsCollection;
  }

  static async getIGLeadMsgs(leadId) {
    const leadMsgsCollection = new Collection(Collections.LEAD_MSGS, {
      createDocument: (src, opts) => new LeadMsg(src, opts),
      query: (ref) => ref
        .where('leadId', '==', leadId)
        .where('provider', '==', ContactProvider.INSTAGRAM)
        .orderBy('sentAt', 'asc'),
    });
    await leadMsgsCollection.fetch();
    return leadMsgsCollection;
  }

  async retryIGMsg() {
    const { FieldValue } = getFirebase().firestore;
    return this.update({
      igMsgStatus: IG_MSG_STATUS.QUEUED,
      errorMessage: FieldValue.delete(),
      failedAt: FieldValue.delete(),
    });
  }
}

export default LeadMsg;
export { IG_MSG_STATUS };
